import React from 'react';
import { ThemeProvider } from "styled-components";
import { BrowserRouter } from "react-router-dom";
import Theme from "../styles/Theme"
import GlobalStyles from '../styles/GlobalStyles'
import Routes from './Routes'
import { useQuery } from '@apollo/react-hooks';
import Header from '../Routes/Header'
import {QUERY} from '../Queries/isLoggedIn'

export default()=>{

  const { data: { auth: { isLoggedIn } } } = useQuery(QUERY)

  return (
    <ThemeProvider theme={Theme}>
      <GlobalStyles />
      <BrowserRouter>
        <Header />
        <Routes 
        isLoggedIn={isLoggedIn}
        />
      </BrowserRouter>
    </ThemeProvider>
  );
}
